export default __webpack_public_path__ + "static/media/three-quarters-circle.7fcbe17e.svg";